import React from 'react';

const CreateAnalysisIcon = () => (
    <svg className="icon create-analysis-icon" viewBox="0 0 20 20">
        <path
            fillRule="evenodd"
            d="M10 20c5.523 0 10-4.477 10-10a9.965 9.965 0 00-.858-4.059 2.251 2.251 0 01-4.392-.691 2.25 2.25 0 01-.691-4.392A9.965 9.965 0 0010 0C4.477 0 0 4.477 0 10s4.477 10 10 10zm2.844-5l-.79-2.344H7.946L7.165 15H4.671L8.906 3.625h2.172L15.336 15h-2.492zM9.992 6.5l-1.414 4.258h2.844L9.992 6.5zM14 3a.75.75 0 01.75-.75h1.5V.75a.75.75 0 011.5 0v1.5h1.5a.75.75 0 010 1.5h-1.5v1.5a.75.75 0 01-1.5 0v-1.5h-1.5A.75.75 0 0114 3z"
        />
    </svg>
);

export default CreateAnalysisIcon;
